import Step from "@mui/material/Step/Step";
import StepLabel from "@mui/material/StepLabel/StepLabel";
import Stepper from "@mui/material/Stepper/Stepper";
import { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box/Box";
import { HelpersService } from "../../../../../services/Helpers";
import { Milestone } from "../../shared/Constants";

type MilestoneBarProps = {
  milestones: Milestone[];
};

export default function MilestoneBar({ milestones }: MilestoneBarProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(HelpersService.checkMobile());
  }, []);

  const activeStep = useMemo(() => {
    if (!milestones.length) {
      return 0;
    }
    const firstIncomplete = milestones.findIndex((m) => !m.done);
    if (firstIncomplete === -1) {
      return milestones.length - 1;
    }
    return Math.max(0, firstIncomplete);
  }, [milestones]);

  if (!milestones.length) {
    return null;
  }

  return (
    <Box className="milestone-bar milestone-bar--inline">
      <div className="milestone-bar__label">Milestones</div>
      <Stepper
        className="milestone-bar__stepper"
        activeStep={activeStep}
        orientation={isMobile ? "vertical" : "horizontal"}
      >
        {milestones.map((m) => (
          <Step key={m.name} completed={m.done}>
            <StepLabel>{m.name}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
